module.exports = {
    currency: {
        style: 'currency',
        currency: 'BRL'
     }
}